// extracted by mini-css-extract-plugin
module.exports = {"banner":"style_banner__E1tfB"};